import clsx from '@/lib/clsx';
import { memo } from 'react';

const Kbd = memo(({ children, className }) => {
  return <kbd className={clsx('comp-kbd', className)}>{children}</kbd>;
});

Kbd.displayName = 'Kbd';

export default Kbd;
